import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { PropertiesListFilters, PropertiesListResponse } from "./types";
import { PROPERTIES_LIST_QUERY_KEY } from "./constants";
import { buildPropertiesQuery } from "./build-properties-query";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. Body-only contract via
 * `httpClient`, not the Orval-generated envelope client.
 */
async function fetchProperties(filters: PropertiesListFilters): Promise<PropertiesListResponse> {
  return httpClient<PropertiesListResponse>(
    `/api/admin/properties${buildPropertiesQuery(filters)}`,
  );
}

export function usePropertiesList(filters: PropertiesListFilters) {
  return useQuery({
    queryKey: [
      ...PROPERTIES_LIST_QUERY_KEY,
      filters.query.trim(),
      filters.status,
      filters.page,
      filters.limit,
    ] as const,
    queryFn: () => fetchProperties(filters),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
